import React from "react";
import Image from "next/image";
import styles from "./AdmissionProcess.module.css";

interface ImageType {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface AdmissionProcessProps {
  data: {
    id: number;
    title: string;
    admission_processes: {
      id: number;
      title: string;
      image: ImageType;
    }[];
  };
}

const AdmissionProcess: React.FC<AdmissionProcessProps> = ({ data }) => {
  const processes = data?.admission_processes || [];
  const isOddCount = processes.length % 2 !== 0;
  
  return (
    <div className={styles.container}>
      <h2>{data?.title}</h2>
      <div className={styles.grid}>
        {processes.map((step, index) => {
          const isLastItem = index === processes.length - 1;
          const shouldCenter = isLastItem && isOddCount;
          
          return (
            <div 
              key={step?.id} 
              className={`${styles.card} ${shouldCenter ? styles.centerLast : ''}`}
            >
              {step?.image?.url && (
                <Image
                  src={step?.image?.url}
                  alt={step?.image?.alternativeText || "AdmissionProcess"}
                  title={step?.image?.alternativeText || "AdmissionProcess"}
                  width={60}
                  height={60}
                  className={styles.cardImg}
                />
              )}
              <p>{step?.title}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdmissionProcess;
